import { call, put, takeEvery } from 'redux-saga/effects';
import { MERGE_CGA_FILE_COLLECTION_DOWNLOAD_API_URL } from '../../../../../constants/ApiUrlConstants';
import { postBlobApiRequest } from '../../../../../features/axiosClient';
import toast from 'react-hot-toast';
import { mergeCGAFileCollectionDownloadFailure, mergeCGAFileCollectionDownloadSuccess } from '../actions';
import { MERGE_CGA_FILE_COLLECTION_DOWNLOAD_REQUEST } from '../../../../../constants/ActionNameConstants';

function* mergeCGAFileCollectionDownloadSaga(action) {
  try {
    const { fileId, fileName } = action.payload;
    const response = yield call(
      postBlobApiRequest,
      MERGE_CGA_FILE_COLLECTION_DOWNLOAD_API_URL,
      {},
      {
        fileId,
      },
    );

    try {
      const text = yield response.data.text();
      const json = JSON.parse(text);

      if ('success' in json && !json.success) {
        const errorMessage =
        json?.errorMessage ||
        json?.exceptionMessage ||
          'Failed to merge CGA file collection';

        yield put(mergeCGAFileCollectionDownloadFailure(errorMessage));
        toast.error(errorMessage);
        return;
      }
    } catch {
    }

    console.log({response})

    const mimeType = response.headers['content-type'] || 'application/octet-stream';  

    const blob = new Blob([response.data], { type: mimeType });

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fileName || 'merged-cga-file-collection');
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);

    yield put(mergeCGAFileCollectionDownloadSuccess(response?.data));
    toast.success('CGA file collection merged successfully');
  } catch (error) {
    yield put(mergeCGAFileCollectionDownloadFailure(error));
    toast.error('Failed to merge CGA file collection');
  }
}

export function* watchMergeCGAFileCollectionDownload() {
  yield takeEvery(MERGE_CGA_FILE_COLLECTION_DOWNLOAD_REQUEST, mergeCGAFileCollectionDownloadSaga);
}
